<template>
  <div>
    <v-radio-group
      row
      dense
      mandatory
      v-model="selected"
      @change="onChange"
      :readonly="readonly"
    >
      <v-radio v-for="item in items" :key="item" :label="item" :value="item" />
    </v-radio-group>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selected: this.value,
    };
  },
  props: {
    items: {
      type: Array,
      require: true,
    },
    value: {
      type: String,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onChange(a) {
      this.$emit('changed', a);
    },
  },
};
</script>
<style scoped>
</style>